/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { FindIngestionSettingsQueryResponse } from "../types/FindIngestionSettings.ts"

export const findIngestionSettingsQueryKey = () =>
  [{ url: "/v1/client-settings/find-ingestion-settings" }] as const

export type FindIngestionSettingsQueryKey = ReturnType<
  typeof findIngestionSettingsQueryKey
>

/**
 * @summary Find ingestion settings
 * {@link /v1/client-settings/find-ingestion-settings}
 */
export async function findIngestionSettings(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindIngestionSettingsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-settings/find-ingestion-settings`,
    ...requestConfig,
  })
  return res
}

export function findIngestionSettingsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findIngestionSettingsQueryKey()
  return queryOptions<
    ResponseConfig<FindIngestionSettingsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindIngestionSettingsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findIngestionSettings(config)
    },
  })
}

/**
 * @summary Find ingestion settings
 * {@link /v1/client-settings/find-ingestion-settings}
 */
export function useFindIngestionSettings<
  TData = ResponseConfig<FindIngestionSettingsQueryResponse>,
  TQueryData = ResponseConfig<FindIngestionSettingsQueryResponse>,
  TQueryKey extends QueryKey = FindIngestionSettingsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindIngestionSettingsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findIngestionSettingsQueryKey()

  const query = useQuery(
    {
      ...findIngestionSettingsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
